import { render, staticRenderFns } from "./AuthNotificationShow.vue?vue&type=template&id=d2f448f4"
import script from "./AuthNotificationShow.vue?vue&type=script&lang=js"
export * from "./AuthNotificationShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports